// Telling touch from mouse input.

// clicks are pointer events in current browsers; older ones fall back to
// whether the primary input can hover
const isTouch = (event) => {
  if (event?.pointerType) return event.pointerType !== `mouse`
  return window.matchMedia(`(hover: none)`).matches
}

// Whether a click on `element` (a map's canvas container) came from a touch,
// told by the press before it: iOS Safari reports a tap's click as a mouse
// one (`pointerType`), while its `pointerdown` is a touch (WebKit bug 282988).
// Call `destroy()` when done, to remove its listener.
export const clickTouchTracker = (element) => {
  let pressPointerType = null
  const pointerDown = (e) => (pressPointerType = e.pointerType || null)
  const options = { capture: true, passive: true }

  element.addEventListener(`pointerdown`, pointerDown, options)

  return {
    isTouch: (event) =>
      pressPointerType ? pressPointerType !== `mouse` : isTouch(event),
    destroy: () =>
      element.removeEventListener(`pointerdown`, pointerDown, options),
  }
}
